import 'normalize.css';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import 'ui-router-extras/release/modular/ct-ui-router-extras.core';
import 'ui-router-extras/release/modular/ct-ui-router-extras.sticky';

import videoPlayerUI from 'videoplayer-ui';
import AppComponent from './app.component';
import Components from './components/components';
import Services from './services/services';
import Filters from './filters/filters';
import appConfig from './app.config';
import appRun from './app.run';
import './constants';

const localConfig = require('./config.json');

const app = angular.module('app', [
  uiRouter,
  Components.name,
  Services.name,
  videoPlayerUI,
  'ct.ui.router.extras.sticky',
  Filters.name
])
  .config(appConfig)
  .run(appRun)
  .component('app', AppComponent);

// used in pagination
app.filter('startFrom', () => {
  return (input, start) => {
    start = parseInt(start, 10);
    return input.slice(start);
  };
});

/*
 Bootstrap the app with properties from underlying java app before starting angular app.
 Instead of automatically bootstrapping angular app from ng-app in html, manually bootstrap
 after first receiving response from /properties endpoint.
 https://blog.mariusschulz.com/2014/10/22/asynchronously-bootstrapping-angularjs-applications-with-server-side-data
 */
function loadConfiguration() {
  const injector = angular.injector(['ng'], true);
  const $http = injector.get('$http');

  return $http.get('/properties').then((res) => {
    angular.module('config', []).value('config', res.data);
  }, () => {
    console.warn('## CONFIG ## Properties endpoint unreachable, using default properties.');
    angular.module('config', []).value('config', localConfig);
  });
}

function getProfile() {
  const injector = angular.injector(['ng', 'profileService', 'auth.authInterceptor'], true);
  const profileService = injector.get('profileService');
  const localService = injector.get('localService');
  const storageKeys = injector.get('storageKeys');

  return profileService.getProfile()
    .then((profile) => {
      localService.set(storageKeys.profile, profile.data);
      let region = localService.get(storageKeys.selectedRegion);
      if (!region) {
        region = profile.data.region;
        if (region) {
          localService.set(storageKeys.selectedRegion, region);
        }
      }
    });
}

function getRegions() {
  const injector = angular.injector(['ng', 'regionService', 'auth.authInterceptor'], true);
  const regionService = injector.get('regionService');
  const localService = injector.get('localService');
  const storageKeys = injector.get('storageKeys');

  return regionService.getRegions()
    .then((regions) => {
      localService.set(storageKeys.regions, regions.data);
    });
}

function authorizeUser() {
  const injector = angular.injector(['ng', 'config', 'auth'], true);
  const $q = injector.get('$q');
  const $timeout = injector.get('$timeout');
  const authService = injector.get('authService');
  // check token expiry every 10 mins and re-authorize if needed
  $timeout(() => {
    console.log('## AUTH ## Re-Authorize');
    authorizeUser();
  }, 10 * 60 * 1000);

  return $q((resolve, reject) => {
    authService.authorize()
      .then(
        (token) => {
          console.info('## AUTH ## Success', token);
          resolve(token);
        },
        (reason) => {
          console.error('## AUTH ## Failure', reason);
          reject(reason);
          document.getElementsByClassName('loading')[0].innerText = 'Sorry, the 612 service failed to load. ' +
            'Please try again.';
        });
  });
}


function appBootstrap() {
  angular.bootstrap(document, ['app'], { strictDi: true });
  console.log('## APP ## Bootstrapped');
}

// Pre-Bootstrap Data Loader phase
loadConfiguration()
  .then(authorizeUser)
  .then(() => {
    const injector = angular.injector(['ng'], true);
    const $q = injector.get('$q');
    return $q.all([
      getProfile(),
      getRegions()
    ]);
  })
  .then(() => {
    console.log('## APP ## Ready');
  })
  .then(appBootstrap);



/** WEBPACK FOOTER **
 ** ./client/app/app.js
 **/